"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Paginator_1 = __importDefault(require("./Paginator"));
exports.default = Paginator_1.default;
//# sourceMappingURL=index.js.map